import m from "react";
import v from "classnames";
import { useTranslation as C } from "react-i18next";
import { PaymentAPI as c } from "../../../../js/payments/paymentApi.js";
import { PaymentUtils as u } from "../../../../js/payments/paymentUtils.js";
import a from "./paymentMethod.module.scss.js";
function k({
  method: o,
  engine: e,
  channel: M,
  active: p,
  design: t,
  texts: r,
  children: f
}) {
  const { t: l } = C(), n = o === c.PaymentMethodType.UNKNOWN ? l(`payments.engine.${e}`) : l(`payments.method.${o}`), h = e === c.PaymentMethodEngine.REDSYS && (r == null ? void 0 : r.redsysPaymentButton) || n, y = o === c.PaymentMethodType.UNKNOWN ? u.toEngineSlug(e) : u.toMethodSlug(o), N = y ? `checkout-payment-method-${y}` : void 0;
  return /* @__PURE__ */ m.createElement(
    "div",
    {
      className: a.container,
      style: {
        "--backgroundColor": (t == null ? void 0 : t.backgroundColor) ?? "#f8f8f8",
        "--textColor": (t == null ? void 0 : t.textColor) ?? "#242323",
        "--activeBackgroundColor": (t == null ? void 0 : t.activeBackgroundColor) ?? "#EA565C",
        "--activeTextColor": (t == null ? void 0 : t.activeTextColor) ?? "#242323"
      }
    },
    /* @__PURE__ */ m.createElement(
      "div",
      {
        "data-testid": N,
        className: v({
          [a.paymentMethodButton]: !0,
          [a.paymentMethodButton__active]: p
        })
      },
      /* @__PURE__ */ m.createElement("div", { className: a.paymentMethodButton__title }, h),
      f
    )
  );
}
export {
  k as PaymentMethod
};
//# sourceMappingURL=PaymentMethod.js.map
